import MypageLayout from 'components/mypage/mypage_layout';
import { FrontendErrorFallback } from 'components/shared/frontend_error_fallback';
import AuthorityStateContainer from 'containers/authority_state_container';
import { UserAuth } from 'containers/user_auth';
import BarcodeIndex from 'pages/mypage/barcode/index';
import BarcodePreview from 'pages/mypage/barcode/preview';
import DefectReportIndex from 'pages/mypage/defect_report/index';
import DefectReportShow from 'pages/mypage/defect_report/show';
import { ExColumnIndex } from 'pages/mypage/ex_column';
import InquiryIndex from 'pages/mypage/inquiry';
import InstrumentImport from 'pages/mypage/instrument/import';
import InstrumentSharingImport from 'pages/mypage/instrument/sharing_import';
import InstrumentIndex from 'pages/mypage/instrument/index';
import InstrumentShow from 'pages/mypage/instrument/show';
import Login from 'pages/mypage/login/index';
import AssetReservationIndex from 'pages/mypage/manager/laboratory/asset_reservations';
import LaboratoryIndex from 'pages/mypage/manager/laboratory/index';
import LaboratoryShow from 'pages/mypage/manager/laboratory/show';
import ProofreadApprovalIndex from 'pages/mypage/proofread_approval';
import ProofreadPlanIndex from 'pages/mypage/proofread_plan';
import ProofreadPlanShow from 'pages/mypage/proofread_plan/show';
import ProofreadableInstrumentIndex from 'pages/mypage/proofreadable_instrument';
import RepairEstimateIndex from 'pages/mypage/repair_estimate';
import RepairEstimateShow from 'pages/mypage/repair_estimate/show';
import RepairEventIndex from 'pages/mypage/repair_event/index';
import RepairEventShow from 'pages/mypage/repair_event/show';
import RepairInfoShow from 'pages/mypage/repair_info/show';
import ReservationIndex from 'pages/mypage/reservation/index';
import RoomIndex from 'pages/mypage/room/index';
import RoomShow from 'pages/mypage/room/show';
import SettingShow from 'pages/mypage/setting/show';
import UnmanagedInstrumentIndex from 'pages/mypage/unmanaged_instrument/index';
import UnprintedBarcodeIndex from 'pages/mypage/unprinted_barcode/index';
import React from 'react';
import { RouteObject } from 'react-router-dom';
import MypageInstrumentSharingRoute from 'containers/mypage_instrument_sharing_route';
import MypageStateContainer from 'containers/mypage_state_container';

/**
 * ルート定義
 */
export class MypageRouteHelper {
  static basePath = (path: string): string => `/mypage/${path}`;

  public static root = (): string => '/mypage';
  // ログイン
  public static login = (): string => MypageRouteHelper.basePath('login');

  // 機器
  public static instrumentIndex = (): string => MypageRouteHelper.basePath('instruments');
  public static instrumentShow = (id: number | string): string => MypageRouteHelper.basePath(`instruments/${id}`);
  public static instrumentImport = (): string => MypageRouteHelper.basePath('import/instruments');
  public static instrumentSharingImport = (): string => MypageRouteHelper.basePath('import/instrument_sharing');

  // QR・バーコード
  public static barcodeIndex = (): string => MypageRouteHelper.basePath('barcodes');
  public static barcodePreview = (): string => MypageRouteHelper.basePath('barcodes/preview');
  public static unprintedBarcodeIndex = (): string => MypageRouteHelper.basePath('unprinted_barcodes');

  // 管理対象外の機器
  public static unmanagedInstrumentIndex = (): string => MypageRouteHelper.basePath('unmanaged_instruments');

  public static defectReportShow = (reportId: number | string): string =>
    MypageRouteHelper.basePath(`defect_reports/${reportId}`);

  // 部屋
  public static roomIndex = (): string => MypageRouteHelper.basePath('rooms');
  public static roomShow = (id: number | string): string => MypageRouteHelper.basePath(`rooms/${id}`);

  public static reservationIndex = (): string => MypageRouteHelper.basePath('reservations');

  public static defectReportIndex = (): string => MypageRouteHelper.basePath('defect_reports');

  public static proofreadPlanIndex = (): string => MypageRouteHelper.basePath('proofread_plans');
  public static proofreadPlanShow = (id: number | string): string =>
    MypageRouteHelper.basePath(`proofread_plans/${id}`);
  public static proofreadApprovalIndex = (): string => MypageRouteHelper.basePath('proofread_approvals');
  public static proofreadableInstrumentIndex = (): string => MypageRouteHelper.basePath('proofreadable_instruments');

  // 修理管理
  public static repairInfoShow = (id: number | string): string => MypageRouteHelper.basePath(`repair_infos/${id}`);

  public static repairEventIndex = (): string => MypageRouteHelper.basePath('repair_events');
  public static repairEventShow = (id: number | string): string => MypageRouteHelper.basePath(`repair_events/${id}`);

  public static repairEstimateIndex = (): string => MypageRouteHelper.basePath('repair_estimates');
  public static repairEstimateShow = (id: number | string): string =>
    MypageRouteHelper.basePath(`repair_estimates/${id}`);

  // 管理情報
  public static exAttributeIndex = (): string => MypageRouteHelper.basePath('ex_attributes');

  // 問合せ
  public static inquiryIndex = (): string => MypageRouteHelper.basePath('inquiries');
  public static inquiryShow = (id: number | string): string => MypageRouteHelper.basePath(`inquiries/${id}`);

  // 設定
  public static settingShow = (): string => MypageRouteHelper.basePath('setting');

  // 管理ラボ
  public static laboratoryIndex = (): string => MypageRouteHelper.basePath('laboratories');
  public static laboratoryShow = (id: number | string): string => MypageRouteHelper.basePath(`laboratories/${id}`);
  public static assetReservationIndex = (): string => MypageRouteHelper.basePath('laboratories/reservations');
}

export const mypageRoutes: RouteObject[] = [
  {
    element: <MypageStateContainer />,
    errorElement: <FrontendErrorFallback />,
    children: [
      { path: MypageRouteHelper.root(), element: <Login /> },
      { path: MypageRouteHelper.login(), element: <Login /> },
      {
        element: <UserAuth />,
        children: [
          {
            element: <MypageLayout />,
            children: [
              {
                element: <AuthorityStateContainer />,
                children: [
                  {
                    // 機器一覧
                    path: MypageRouteHelper.instrumentIndex(),
                    element: <InstrumentIndex />,
                  },
                  {
                    // 機器詳細
                    path: MypageRouteHelper.instrumentShow(':id'),
                    element: <InstrumentShow />,
                  },
                  {
                    // バーコード一覧
                    path: MypageRouteHelper.barcodeIndex(),
                    element: <BarcodeIndex />,
                  },
                  {
                    // バーコードプレビュー
                    path: MypageRouteHelper.barcodePreview(),
                    element: <BarcodePreview />,
                  },
                  {
                    // 未印刷バーコード一覧
                    path: MypageRouteHelper.unprintedBarcodeIndex(),
                    element: <UnprintedBarcodeIndex />,
                  },
                  {
                    // 管理対象外の機器
                    path: MypageRouteHelper.unmanagedInstrumentIndex(),
                    element: <UnmanagedInstrumentIndex />,
                  },
                  {
                    // 部屋一覧
                    path: MypageRouteHelper.roomIndex(),
                    element: <RoomIndex />,
                  },
                  {
                    // 部屋詳細
                    path: MypageRouteHelper.roomShow(':id'),
                    element: <RoomShow />,
                  },
                  {
                    // マイカレンダー
                    path: MypageRouteHelper.reservationIndex(),
                    element: <ReservationIndex />,
                  },
                  {
                    // 不具合報告一覧
                    path: MypageRouteHelper.defectReportIndex(),
                    element: <DefectReportIndex />,
                  },
                  {
                    // 不具合報告詳細
                    path: MypageRouteHelper.defectReportShow(':id'),
                    element: <DefectReportShow />,
                  },
                  {
                    // 修理結果一覧
                    path: MypageRouteHelper.repairEventIndex(),
                    element: <RepairEventIndex />,
                  },
                  {
                    // 修理結果詳細
                    path: MypageRouteHelper.repairEventShow(':id'),
                    element: <RepairEventShow />,
                  },
                  {
                    // 修理見積一覧
                    path: MypageRouteHelper.repairEstimateIndex(),
                    element: <RepairEstimateIndex />,
                  },
                  {
                    // 修理見積詳細
                    path: MypageRouteHelper.repairEstimateShow(':id'),
                    element: <RepairEstimateShow />,
                  },
                  {
                    // 修理情報
                    path: MypageRouteHelper.repairInfoShow(':id'),
                    element: <RepairInfoShow />,
                  },
                  {
                    // 校正計画一覧
                    path: MypageRouteHelper.proofreadPlanIndex(),
                    element: <ProofreadPlanIndex />,
                  },
                  {
                    // 校正計画詳細
                    path: MypageRouteHelper.proofreadPlanShow(':id'),
                    element: <ProofreadPlanShow />,
                  },
                  {
                    // 校正承認一覧
                    path: MypageRouteHelper.proofreadApprovalIndex(),
                    element: <ProofreadApprovalIndex />,
                  },
                  {
                    // 校正対象機器一覧
                    path: MypageRouteHelper.proofreadableInstrumentIndex(),
                    element: <ProofreadableInstrumentIndex />,
                  },
                  {
                    // 管理情報
                    path: MypageRouteHelper.exAttributeIndex(),
                    element: <ExColumnIndex />,
                  },
                  {
                    // 問合せ
                    path: MypageRouteHelper.inquiryShow(':id'),
                    element: <InquiryIndex />,
                  },
                  {
                    // 機器インポート
                    path: MypageRouteHelper.instrumentImport(),
                    element: <InstrumentImport />,
                  },
                  {
                    // 設定画面
                    path: MypageRouteHelper.settingShow(),
                    element: <SettingShow />,
                  },
                  {
                    // すべての予約
                    path: MypageRouteHelper.assetReservationIndex(),
                    element: <AssetReservationIndex />,
                  },
                  {
                    // 管理ラボ
                    path: MypageRouteHelper.laboratoryIndex(),
                    element: <LaboratoryIndex />,
                  },
                  {
                    // 管理ラボ詳細
                    path: MypageRouteHelper.laboratoryShow(':id'),
                    element: <LaboratoryShow />,
                  },
                  {
                    element: <MypageInstrumentSharingRoute />,
                    // 機器共有が有効な場合のみ以下のルートを追加
                    children: [
                      {
                        // 機器共有インポート
                        path: MypageRouteHelper.instrumentSharingImport(),
                        element: <InstrumentSharingImport />,
                      },
                      {
                        // 問合せ一覧
                        path: MypageRouteHelper.inquiryIndex(),
                        element: <InquiryIndex />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
